import React from 'react'
import { Container, Row } from 'react-bootstrap';
import InformationProperties from './InformationProperties';
import PropertyWidgets from './PropertyWidgets';

const AddEarning = () => {

  document.title = "Add Properties";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid >
          <Row>
            <InformationProperties editData={null} isEdit={false } />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddEarning;
